import {RsnButton, RsnInput} from '@raison/ui-kit';
import React, {Fragment, useEffect, useState} from 'react';
import {Link} from 'react-router';
import {CONTACT_US_MESSAGE, SERVICE_UNAVAILABLE_MESSAGE} from '~/config';
import {accountClosureGet, accountClosurePost, logout} from '~/entities/user';
import {ErroneousServerResult, useHttpClient} from '~/library/network-facade';
import Countdown from '~/shared/legacy_presentational-components/Countdown/Countdown';
import {useAppDispatch} from '~/shared/store';
import styles from './ConfirmAccountClosure.module.scss';

interface Props {
    phoneNumber: string;
    onSuccess?: () => void;
}

export const ConfirmAccountClosure = ({phoneNumber, onSuccess}: Props) => {
    const [smsCode, setSmsCode] = useState('');
    const [uuid, setUuid] = useState('');
    const [apiError, setApiError] = useState<ErroneousServerResult | null>(null);
    const http = useHttpClient();
    const dispatch = useAppDispatch();

    useEffect(() => {
        (async () => sendRequest('get'))();
    }, []);

    const sendRequest = async (type: 'get' | 'post') => {
        if (type === 'get') {
            const {status, json} = await accountClosureGet(http);
            if (status === 401) {
                dispatch(logout());
                return;
            }
            if (status === 400) return setApiError(json);
            setUuid(json.uuid);
        }
        if (type === 'post') {
            const {status, json} = await accountClosurePost(http, {uuid, code: smsCode});
            if (status === 401) {
                dispatch(logout());
                return;
            }
            if (status === 400) return setApiError(json);
            onSuccess?.();
        }
    };

    const onChange = (value: string) => {
        setSmsCode(value);
        setApiError(null);
    };

    const issue = (() => {
        const responseErrorGroup = apiError?.code?.toString()?.charAt(0);
        const errorMessage = responseErrorGroup === '5' ? SERVICE_UNAVAILABLE_MESSAGE : apiError?.message;
        if (errorMessage?.includes(CONTACT_US_MESSAGE)) {
            const [mainPart, ...rest] = errorMessage.split(`${CONTACT_US_MESSAGE}`);
            return (
                <>
                    {mainPart}
                    <Link to='/support/form'>{CONTACT_US_MESSAGE}</Link>
                    {rest.join('')}
                </>
            );
        } else {
            return errorMessage;
        }
    })();

    return (
        <Fragment>
            <div className={styles.container}>
                <div className={styles.stretched}>
                    <div>
                        <div className={styles.title}>One-time code</div>
                        <div className={styles.text}>
                            Enter the one-time code we just sent
                            <br /> to <span className={styles.phone}>{phoneNumber}</span>.
                        </div>
                    </div>
                    <RsnInput
                        label={'Code'}
                        value={smsCode}
                        issue={issue}
                        onChange={({currentTarget: {value}}) => onChange(value)}
                    />
                    <Countdown
                        seconds={600}
                        resendHandler={() => sendRequest('get')}
                        accountClosure
                        resendStyles={styles.resend}
                    />
                </div>
                <RsnButton onClick={() => sendRequest('post')} className={styles.submit}>
                    Close my account
                </RsnButton>
            </div>
        </Fragment>
    );
};
